"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FastForwardHandler = function FastForwardHandler(_ref) {
  var _this = this;

  var stateSelector = _ref.stateSelector,
      onPause = _ref.onPause,
      handleOverrideCurrentTime = _ref.handleOverrideCurrentTime,
      onUpdateFastForwardState = _ref.onUpdateFastForwardState;

  _classCallCheck(this, FastForwardHandler);

  _defineProperty(this, "stopFastForward", function () {
    clearInterval(_this._fastForwardInterval);
    _this._fastForwardInterval = null;

    _this.onUpdateFastForwardState({
      isFastForwarding: false,
      playing: false
    });
  });

  _defineProperty(this, "fastForward", function (_ref2) {
    var isFastForwarding = _ref2.isFastForwarding;

    if (isFastForwarding && _this._fastForwardInterval) {
      _this.onPause();

      return void _this.stopFastForward();
    }

    _this.onUpdateFastForwardState({
      isFastForwarding: true,
      playing: true
    });

    _this._fastForwardInterval = setInterval(function () {
      if (!_this._fastForwardInterval) {
        return void _this.onUpdateFastForwardState({
          isFastForwarding: false,
          playing: false
        });
      }

      var _this$playerStateSele = _this.playerStateSelector(),
          currentTime = _this$playerStateSele.currentTime,
          playing = _this$playerStateSele.playing;

      if (_this._fastForwardInterval && (currentTime <= 0 || !playing)) {
        return void _this.stopFastForward();
      }

      _this.handleOverrideCurrentTime(currentTime + 0.4, {
        skipPause: true
      });
    }, 50);
  });

  this.playerStateSelector = stateSelector;
  this.handleOverrideCurrentTime = handleOverrideCurrentTime;
  this.onPause = onPause;
  this.onUpdateFastForwardState = onUpdateFastForwardState;
};

exports.default = FastForwardHandler;